import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import {
  DELETE_PENDING_AUTH_FILE_DOC_SUCCESS,
  POST_PENDING_AUTH_FILE_DOC_SUCCESS,
  getAuthDocuments,
  getTempPendingFileDocs,
  deleteTempPendingFileDoc,
  insertTempPendingFileDoc,
} from '../authorizations.actions';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS, showToast } from '../../layout/layout.actions';
import { withStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import React from 'react';
import TextField from '@material-ui/core/TextField';

import ResponsiveDialog from '../../../common/responsiveDialog.component';

import Dropzone from 'react-dropzone';

// import { BASE_URL } from '../../../middleware/api';
import { generateForm } from '../../../utilities/reportingUtils';
import { getAuthToken } from '../../../utilities/authUtils';
import { getDataUrlFromFile, isFileExtensionBlocked, maxFileUploadSize } from '../../../utilities/fileUtils';
import { Box } from '@material-ui/core';

// const request = require('superagent');

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '100%',
  },
  menu: {
    width: 200,
  },
  paperSection: {
    width: '100%',
    padding: '1rem',
    marginBottom: '0.75rem',
  },
  listItemTextRoot: {
    wordWrap: 'break-word',
  },
});

const DIALOG_CONFIRM_DELETE = 'DIALOG_CONFIRM_DELETE';

class NotesForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: {
        modalConfirmOpen: false,
        contentText: '',
        type: null,
        selectedDoc: null,
      },
    };

    this.handleFileDrop = this.handleFileDrop.bind(this);
    this.getAuthDocuments = this.getAuthDocuments.bind(this);
    this.handleDeleteDocument = this.handleDeleteDocument.bind(this);
    this.handleModalResponse = this.handleModalResponse.bind(this);
    this.doDocumentDelete = this.doDocumentDelete.bind(this);
    this.download = this.download.bind(this);
  }

  componentWillMount() {
    this.getAuthDocuments();
  }

  componentDidUpdate(prevProps) {
    // a new authorization gets its tempFileId once it is first saved
    if (prevProps.formData.selectedAuth.tempFile.tempFileId !== this.props.formData.selectedAuth.tempFile.tempFileId) {
      this.getAuthDocuments();
    }
  }

  handleChange = (name) => (event) => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleDeleteDocument(id) {
    this.setState({
      modal: {
        modalConfirmOpen: true,
        contentText: 'Delete this document?',
        type: DIALOG_CONFIRM_DELETE,
        selectedDoc: id,
        title: 'Confirm Deletion',
      },
    });
  }

  handleModalResponse(response, type) {
    switch (type) {
      case DIALOG_CONFIRM_DELETE:
        if (response) {
          this.doDocumentDelete(this.state.modal.selectedDoc);
        }
        break;

      default:
        break;
    }
    this.setState({ modal: { modalConfirmOpen: false, contentText: '', type: null, title: '' } });
  }

  async doDocumentDelete(id) {
    let resp = await this.props.deleteTempPendingFileDoc(id);
    if (resp && resp.type === DELETE_PENDING_AUTH_FILE_DOC_SUCCESS) {
      this.props.showToast('Document deleted successfully.', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
      this.props.getTempPendingFileDocs(this.props.formData.selectedAuth.tempFile.tempFileId);
    } else {
      this.props.showToast('Error deleting document. Please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    }
  }

  getAuthDocuments() {
    if (this.props.formData) {
      let authId = this.props.formData.selectedAuth.tempFile.tempFileId;
      if (authId) {
        this.props.getTempPendingFileDocs(authId);
      }
    }
  }

  download(RecordID, AuthorizationID) {
    let postObj = {
      access_token: getAuthToken(),
      AuthorizationID,
      RecordID,
    };

    generateForm('Authorization/GetDocument', postObj);
  }

  async handleFileDrop(accepted, rejectedFile) {
    let authId = this.props.formData.selectedAuth.tempFile.tempFileId;

    // documents are linked to the temp file, so the authorization has to be saved first
    if (!authId) {
      return;
    }

    for (const file of accepted) {
      let fileName = file.name;
      let fileNameAry = fileName.split('.');
      let fileExtension = fileNameAry.length > 1 ? fileNameAry.pop() : '';

      const isFileBlocked = isFileExtensionBlocked(fileExtension);

      if (!isFileBlocked) {
        const dataUrl = await getDataUrlFromFile(file);

        let newFile = {
          base64FileData: dataUrl.split(',')[1], // Remove the data:<contentType>;base64, part
          fileName: file.name,
          contentType: file.type || 'application/octet-stream',
        };

        // uploads to blob storage and links the attachment to the temp file
        let resp = await this.props.insertTempPendingFileDoc(newFile, authId);
        if (resp.type !== POST_PENDING_AUTH_FILE_DOC_SUCCESS) {
          this.props.showToast(`Error uploading ${file.name}. Please try again.`, { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        }
      }
    }

    this.props.getTempPendingFileDocs(authId);
  }

  render() {
    const { classes, handleFormChange, formData, readonly, disabled } = this.props;
    // the store can still hold documents from a previously viewed authorization until this one is saved
    const authDocuments = disabled ? [] : this.props.authDocuments;
    const { notes, AuthorizationID } = formData.selectedAuth.tempFile || formData.selectedAuth;
    const { modalConfirmOpen, contentText, type, selectedDoc, title } = this.state.modal;

    if (!formData) {
      return <div />;
    }

    return (
      <form className={classes.container} noValidate autoComplete="off">
        <ResponsiveDialog
          fullScreen={false}
          open={modalConfirmOpen}
          contentText={contentText}
          type={type}
          handleResponse={this.handleModalResponse}
          selectedDoc={selectedDoc}
          title={title}
        />

        <Paper className={classes.paperSection}>
          <h3>Notes</h3>
          <Grid container>
            <TextField
              id="notes"
              label="Notes"
              multiline
              className={classes.textField}
              value={notes || ''}
              onChange={handleFormChange('notes')}
              margin="normal"
              disabled={readonly}
              inputProps={{ maxLength: 1000 }}
            />
          </Grid>
        </Paper>

        <Paper className={classes.paperSection}>
          <Grid container alignItems="flex-start">
            {!readonly &&
              <Grid xs={12} md={6} item>
                <h3>Upload Documents</h3>
                {disabled ?
                  <div style={{ margin: '0.5rem' }}>Save the authorization before uploading documents.</div>
                  :
                  <>
                    <Dropzone
                      // accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, text/plain, application/pdf"
                      maxSize={maxFileUploadSize}
                      onDrop={this.handleFileDrop}
                      style={{
                        borderColor: 'black',
                        borderStyle: 'dashed',
                        borderRadius: '0.5rem',
                        height: '100%',
                        width: '100%',
                        cursor: 'pointer',
                      }}
                    >
                      <div style={{ margin: '0.5rem' }}>Drop files here, or click to select files to upload.</div>
                    </Dropzone>

                    <Box sx={{ marginLeft: '10px' }}>
                      <Box sx={{ backgroundColor: 'gray', height: '1px', width: '75px', marginTop: '10px', marginBottom: '5px' }}> </Box>
                      <Box sx={{ color: 'gray', fontSize: '10px' }}>{`[ Max: ${maxFileUploadSize / 1000000} MB ]`}</Box>
                    </Box>
                  </>
                }
              </Grid>
            }
            <Grid xs={12} md={6} item>
              <h3>Uploaded Documents</h3>
              <List style={{ border: '1px solid', marginTop: 10, minHeight: 100 }} >
                {authDocuments &&
                  authDocuments.map((d) =>
                  (<ListItem key={d.attachmentId}>
                    <ListItemAvatar>
                      <IconButton onClick={() => this.download(d.attachmentId, AuthorizationID)}>
                        <FontAwesomeIcon icon="file-download" />
                      </IconButton>
                    </ListItemAvatar>
                    <ListItemText
                      classes={{ root: classes.listItemTextRoot }}
                      primary={d.fileName}
                    // secondary='Secondary text'
                    />
                    {!readonly &&
                      <ListItemSecondaryAction>
                        <IconButton aria-label="Delete" onClick={() => this.handleDeleteDocument(d.attachmentId)}>
                          <DeleteIcon />
                        </IconButton>
                      </ListItemSecondaryAction>
                    }
                  </ListItem>),
                  )
                }
              </List>
            </Grid>
          </Grid>
        </Paper>
      </form>
    );
  }
}

NotesForm.propTypes = {

};

const mapStateToProps = (state) => {
  return {
    authDocuments: state.authorizations.get('authDocuments'),
  };
};

NotesForm = withStyles(styles)(NotesForm);

export default connect(mapStateToProps, {
  getAuthDocuments,
  getTempPendingFileDocs,
  deleteTempPendingFileDoc,
  insertTempPendingFileDoc,
  showToast,
})(NotesForm);

